// extracted by mini-css-extract-plugin
module.exports = {"header":"Tabs-module--header--37pef","tabName":"Tabs-module--tabName--V5BcS","active":"Tabs-module--active--2olBj"};